import React from 'react'
import { useRouteMatch } from "react-router-dom";

import './css/components.css'


/*******************************************************************************
Components
*******************************************************************************/


export function Image({ name, file, alt, caption, width, audio }) {
  // let path = useRouteMatch().path;
  let path = `/sites/${name}`;

  return (
    <div className={'imagebox' + (audio ? '' : ' spacer')} >
      <img
        alt={alt}
        className='image'
        src={`${path}/images/${file}`}
        style={{ maxWidth: width }} />
      {caption ? <ImageCaption text={caption} width={width} /> : null}
      {audio ? <Audio name={name} file={audio} /> : null}
    </div>
  );
};


/*******************************************************************************
Subcomponents
*******************************************************************************/


export function Audio({ name, file, title, caption }) {
  // let path = useRouteMatch().path;
  let path = `/sites/${name}`;
  return (
    <div>
      {title ? <div className='audio-title'>{title}</div> : null}
      <audio className='audio-single' controls>
        <source src={`${path}/audio/${file}`} type='audio/mpeg' />
      </audio>
      {caption ? <div className='caption'>{caption}</div> : null}
    </div>);
};


export function Download({ url, text }) {
  return (
    <a className='iconbox download text-24-responsive' href={url}>{text}</a>
  );
}


function ImageCaption({ text, width }) {
  return <div className='caption' style={{ maxWidth: width }}>{text}</div>;
}
